
import React from 'react';
import {Line} from 'react-chartjs-2';




export default function InsightsGraphAnswerRate({ stepsCounts }) {

    const graphData = (canvas) => {
    
      const ctx = canvas.getContext("2d")
      const gradient = ctx.createLinearGradient(0, 0, 0, 350);
      gradient.addColorStop(0, 'rgba(98, 2, 238, 0.7)');
      gradient.addColorStop(1, 'rgba(236, 225, 253, 0)');

      return {
    
        labels: stepsCounts.map( (s,i) => `s.${i+1}`),
        datasets: [
          {
            lineTension: 0.0,
            backgroundColor: gradient,
            borderColor: '#6202EE',
            borderWidth: 3,
            data: stepsCounts,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: '#6202EE',
            pointBackgroundColor: 'rgba( 98, 2, 238, 0 )',
            pointHoverBorderWidth: 0.00001,
            pointRadius: 10,
            pointBorderWidth: 0.00001,
          }
        ]
    
      }
      
    }
  
    return (
    
        <Line
          data={graphData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            legend:{
              display: false,
              position:'right'
            },
            scales: {
              yAxes: [{
                  gridLines: {
                      display: false
                  },
                  ticks: {
                      stepSize: 100
                  }
              }]
            },
            tooltips: {
              titleFontSize: 14,
              bodyFontSize: 14,
              xPadding: 12,
              yPadding: 8,
              displayColors: false,
            }
          }}
        />
     
    );
  
}